import React from "react";
import { KINDS, outcomeTag } from "./boardUtils";

export const BoardMagnet = ({ m, onClick, overdue, showWho, selected, selectMode }) => {
  const k = KINDS[m.kind] || KINDS.job;
  const name = m.client_full || (m.client_name || "").split(" - ")[0];
  if (m.finished) return (
    <div onClick={() => onClick(m)} data-testid={`board-magnet-${m.id}`} title={`${outcomeTag(m)} - ${m.text}`}
      className="relative cursor-pointer rounded-md border-l-4 border-slate-400 bg-slate-100 px-1.5 py-1 text-[11px] leading-tight text-slate-500 opacity-80 hover:opacity-100 transition-opacity">
      <div className="flex items-center gap-1">
        <span className="h-3.5 w-3.5 shrink-0 rounded-full bg-slate-500 text-white text-[9px] font-black flex items-center justify-center">✓</span>
        {showWho && <span className="text-[9px] font-black text-white bg-slate-500 rounded px-1">{(m.assigned_to || "All").split(" ")[0]}</span>}
        <span className="font-bold line-clamp-1 break-words min-w-0 line-through decoration-slate-400" data-testid="magnet-head">{name || m.text}</span>
      </div>
      <div className="flex items-center gap-1 mt-0.5">
        <span className="rounded bg-slate-500 px-1 text-[9px] font-black uppercase text-white" data-testid={`magnet-outcome-${m.id}`}>{outcomeTag(m)}</span>
        {m.wo_number && <span className="ml-auto text-[9px] font-mono">#{m.wo_number}</span>}
      </div>
    </div>
  );
  const head = m.kind === "away" ? "AWAY / OUT" : name ? `${name}${m.client_suburb ? ` - ${m.client_suburb}` : ""}` : null;
  return (
    <div
      draggable
      onDragStart={(e) => { e.dataTransfer.setData("text/plain", m.id); e.dataTransfer.effectAllowed = "move"; }}
      onClick={() => onClick(m)}
      data-testid={`board-magnet-${m.id}`}
      title={m.text}
      className={`group relative cursor-grab active:cursor-grabbing rounded-md border-l-4 px-1.5 py-1 text-[11px] leading-tight shadow-sm hover:shadow-md hover:-translate-y-px transition-[transform,box-shadow] ${selected ? "ring-2 ring-sky-600 ring-offset-1" : ""}`}
      style={{ background: k.bg, borderColor: k.color }}
    >
      <div className="flex items-center gap-1">
        {selectMode ? <input type="checkbox" readOnly checked={!!selected} data-testid={`board-magnet-check-${m.id}`} className="h-3 w-3 shrink-0 pointer-events-none" />
          : <span className="h-1.5 w-1.5 rounded-full shrink-0" style={{ background: k.color }} />}
        {showWho && <span className="text-[9px] font-black text-white bg-slate-700 rounded px-1">{(m.assigned_to || "All").split(" ")[0]}</span>}
        <span className="font-bold line-clamp-2 break-words min-w-0" style={{ color: k.color }} data-testid="magnet-head">{head || m.text}</span>
        {m.wo_number && <span className="ml-auto text-[9px] font-mono text-slate-500">#{m.wo_number}</span>}
      </div>
      {m.handover && (m.handover.to || "") === (m.assigned_to || "") && <div className={`text-[9px] font-black ${m.handover.accepted ? "text-green-700" : "text-amber-700"}`} data-testid={`magnet-handover-${m.id}`}>{m.handover.accepted ? `✓ Accepted by ${m.handover.to.split(" ")[0]}` : "Not accepted yet"}</div>}
      {head && <div className="text-slate-700 line-clamp-2 break-words" data-testid="magnet-why">{m.text}</div>}
      {overdue && <div className="text-[9px] font-bold text-red-600">{m.due_date.split("-").reverse().join("/")}</div>}
    </div>
  );
};
